<template>
  <div>
    <div style="width: 100%; margin-bottom: 20px; text-align: center;">
      <div class="tag-group" style="display: block; margin: 10px 0;">
        <div class="group-name">Click to Filter by Prediction</div>
        <div v-for="(item, index) in predictions" :key="index"
          @click="tagsUpdate(item.name, 'predictions')"
          :style="`background-color: ${item.color}; color: ${item.textColor}; ${isSelected(item.name)}`"
          class="filter-chip race-state tag-selector">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'

const props = {
  tags: {
    type: Array,
    required: true
  }
}

const methods = {
  tagsUpdate (tag, group) {
    if (this.groups[group] === tag) {
      this.groups[group] = null
    } else {
      this.groups[group] = tag
    }
    let tags = cloneDeep(this.tags)
    tags = Object.values(this.groups).filter(e => e)
    this.$emit('tag-update', tags)
  },
  isSelected (tag) {
    if (this.tags.includes(tag)) {
      return 'opacity: 1; border: 1px solid #333;'
    }
  }
}

export default {
  props,
  methods,
  data () {
    return {
      groups: {
        predictions: 'Toss Up'
      },
      predictions: [
        { name: 'Safe D', color: '#66abcf', textColor: '#fff' },
        { name: 'Likely D', color: '#a5c9df', textColor: '#333' },
        { name: 'Lean D', color: '#dde9f0', textColor: '#333' },
        { name: 'Toss Up', color: '#854C79', textColor: '#fff' },
        { name: 'Lean R', color: '#ffbeb7', textColor: '#333' },
        { name: 'Likely R', color: '#ff998e', textColor: '#333' },
        { name: 'Safe R', color: '#FA3138', textColor: '#fff' }
      ]
    }
  }
}
</script>

<style>
.tag-group {
  margin: 0 10px;
  display: inline-block;
}

.group-name {
  font-size: 0.9em;
  letter-spacing: 0.02em;
  color: #9E9E9E;
  margin-bottom: 5px;
  text-align: center;
}

.tag-selector {
  display: inline-block;
  width: 65px;
  font-size: 0.7em !important;
  padding: 2px 8px !important;
  opacity: 0.3;
  cursor: pointer;
  margin: 2px 3px !important;
}

.tag-selector:hover {
  opacity: 0.9;
}

@media only screen and (max-width: 960px) {
  .tag-selector:hover {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TagSelector.vue